module.exports = "<span class=label-datetime-formatted> {{FormattedDate}} </span>";